module.exports = __webpack_public_path__ + "media/assets/images/placeholder_cover_image-9e23b180b67847b284dce644e1cf96e4.jpg";